// extracted by mini-css-extract-plugin
export var details = "_hq-0";
export var inspectorPopover = "_hq-1";